// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"49ccb12c","223":"9c9b509c","321":"64d4b07e","433":"a679f6bf","573":"d3e5f711","830":"f2f777e1"}[chunkId] + ".chunk.js";
};